import {HTMLProps} from "react";


const Text = (props: HTMLProps<HTMLDivElement>) => {
    const { className, ...divProps } = props;
    return (
        <div className={`text-black ${className || ""}`} {...divProps}>{props.children}</div>
    )
}

export default Text;